import React from "react";

const ConfirmationATM = ({
  show,
  onClose,
  onConfirm,
  title = "Confirm Delete",
  message = "Are you sure?",
  buttonText='Delete'
}) => {
  if (!show) return null;

  return (
    <div
      className="modal fade show d-flex justify-content-center "
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div
        className="modal-dialog"
        style={{ position: "absolute", marginTop: "25vh" }}
        role="document"
      >
        <div className="modal-content text-center">
          <div className="modal-header justify-content-center ">
            <h5 className="modal-title w-100 border-b-1 fw-bold">{title}</h5>
          </div>
          <div className="modal-body bold fw-semibold">{message}</div>
          <div className="modal-footer justify-content-end border-0">
            <button
              type="button"
              className="btn btn-secondary mx-2"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-danger mx-2"
              onClick={onConfirm}
            >
              {buttonText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationATM;
